var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Movies",
    "data-name": "Icon / Movies",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "local_movies-black-18dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12,18H4V16H2v2H0V0H2V2H4V0h8V2h2V0h2V18H14V16H12v2ZM6,2V16h4V2Zm6,10v2h2V12ZM2,12v2H4V12ZM12,8v2h2V8ZM2,8v2H4V8ZM12,4V6h2V4ZM2,4V6H4V4Z",
    transform: "translate(4 3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrip);
export default __webpack_public_path__ + "static/media/icon-strip.70f8fa3a33cb40f9266f6d5067404989.svg";
export { ForwardRef as ReactComponent };